var echarts = require("../echarts");

var zrUtil = require("zrender/lib/core/util");

require("./effectScatter/EffectScatterSeries");

require("./effectScatter/EffectScatterView");

var visualSymbol = require("../visual/symbol");

var layoutPoints = require("../layout/points");

echarts.registerVisual(zrUtil.curry(visualSymbol, 'effectScatter', 'circle', null));
echarts.registerLayout(zrUtil.curry(layoutPoints, 'effectScatter'));


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/effectScatter.js
// module id = 914
// module chunks = 0